import * as api from '../../api';
import { getCdnImageUrl } from "../../functions";
import { getCustomerGuid, getCustomerEmail } from "../../customer";

export const addChild = function () {

	return `<div id="sub-step2" style="display: none">
	                <div class="sub-order-box">
	                    <button  type="button" class="sub-exit"><img src="${getCdnImageUrl(`/user/documents/upload/subimg/cross.svg`)}"></button>
	                    <h3>Vyberte dítě pro které předplatné chcete</h3>
	                    <form id="add-child-form">
	                        <input id="sub-add-name" required="required" type="text" placeholder="Jméno">
	                        <div class="sub-add-date">
	                            <label>
	                              <span>Datum narození</span>
	                              <input id="sub-add-date" type="date" placeholder="Datum narození">
	                            </label>
	                            <p>Proč potřebujeme datum narození<span class="sub-tooltip">Rádi bychom, aby vaše předplatné bylo miminku šité na míru. Pokud například nějaký produkt bude nedostupný, nabídneme vám relevantní náhradu.</span></p>
	                        </div>
	                        <button type="submit" id="subscription-confirm-child" class="subscription-button">Přidat dítě</button>
	                    </form>
	                </div>     
	            </div>`
}

$(document).on('submit', '#add-child-form', function (e) {
	e.preventDefault();
	var form = $(this);
	var name = form.find('#sub-add-name').val();
	var email = getCustomerEmail();
	var birthDate = form.find('#sub-add-date').val() || null;

	showSpinner();
	api.postData(
		'insert-child',
		{name, email, birthDate},
		{ guid: getCustomerGuid() },
	).done(function (data) {
		var selector = '.sub-order-cards .sub-order-card:last';
		if($(selector).length === 0) {
			$('.sub-order-cards .addChild').before(`
			<input required="required" type="radio" id="child_${data.id}" name="child" value="${data.id}" checked>
			<label for="child_${data.id}" class="sub-order-card"><span>${name}</span></label>
		`);
		} else {
			$(selector).after(`
			<input required="required" type="radio" id="child_${data.id}" name="child" value="${data.id}" checked>
			<label for="child_${data.id}" class="sub-order-card"><span>${name}</span></label>
		`);
		}

		$('#sub-step1').show();
		$('#sub-step2').hide();
		form.find('input').val('');
		hideSpinner();
	})
})
